import React from 'react';

export const TableViewCallout: React.FC = () => {
  // TODO RMK-1530
  return null;
};
